module.exports = __webpack_public_path__ + "img/2000.a164a9b7.png";